import React, { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { applyTheme, resolveTheme } from '../config/theme';

// Client-side navigation never re-runs initializeTheme(), so the theme is
// re-resolved per route: marketing pages force light, app pages restore the
// visitor's stored choice.
const ThemeRoutePolicy: React.FC = () => {
    const location = useLocation();

    useLayoutEffect(() => {
        applyTheme(resolveTheme(location.pathname));
    }, [location.pathname]);

    return null;
};

export default ThemeRoutePolicy;
